<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

/**
 * RED-355: an outside data service (X-Road, the land register, a map service) is limiting our
 * requests. The server puts its translated sentence ("try again in about N min") in the shared
 * errors bag under `outbound` — after a form submission, or for a deferred section that could not
 * load (App\Exceptions\Outbound\RateLimitedResponse). Shown inline on the page, never a toast.
 */
const page = usePage()
const sentence = computed(() => page.props.errors?.outbound ?? null)
</script>

<template>
  <div v-if="sentence" class="container mx-auto px-4 pt-4">
    <Message severity="warn" :closable="false" data-testid="outbound-limit-notice">
      {{ sentence }}
    </Message>
  </div>
</template>
